export default __webpack_public_path__ + "static/media/img (2).63feb1b5.jpg";